
export  function isAdmin(profile) {
    return(profile.roles && profile.roles.indexOf("Admin") !== -1)
}


// WEBPACK FOOTER //
// ./src/helpers/profileHelpers.js